import type { CustomErrorRule } from '@/core/error/transport/types'
import { oauthEndpointProvidersPredicateFn } from '@/services/transport/errorsProcessing/rules/oauth/types'
import { TmAuthAccountSubAccountClosedError } from '@/core/error/transport/auth/TmAuthAccountSubAccountClosedError'

export const oauthSubAccountClosedErrorRule: CustomErrorRule = {
  predicateFn: oauthEndpointProvidersPredicateFn,
  subCodes: ['auth.subaccount_closed'],
  klass: TmAuthAccountSubAccountClosedError,
}
